/**
 * nativeStorage — localStorage wrapper with Capacitor fallback
 */
const nativeStorage = {
  getItem: (key) => {
    try { return localStorage.getItem(key); } catch { return null; }
  },
  setItem: (key, value) => {
    try { localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value)); } catch {}
  },
  removeItem: (key) => {
    try { localStorage.removeItem(key); } catch {}
  },
  clear: () => {
    try { localStorage.clear(); } catch {}
  },
};

export default nativeStorage;
